export const CONTENT_TYPE_HTML = 'html';
export const CONTENT_TYPE_TEXT = 'text';
